var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHoldOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 89,
    viewBox: "0 0 108 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_8264_81679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 27C32 19.268 38.268 13 46 13H62C69.732 13 76 19.268 76 27V43C76 50.732 69.732 57 62 57H46C38.268 57 32 50.732 32 43V27Z",
    fill: "url(#paint0_linear_8264_81679)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_8264_81679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 27C32 19.268 38.268 13 46 13H62C69.732 13 76 19.268 76 27V43C76 50.732 69.732 57 62 57H46C38.268 57 32 50.732 32 43V27Z",
    fill: "url(#paint1_linear_8264_81679)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8264_81679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 45C59.5228 45 64 40.5228 64 35C64 29.4772 59.5228 25 54 25C48.4772 25 44 29.4772 44 35C44 40.5228 48.4772 45 54 45Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8984 27.8984L61.0984 42.0984",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_8264_81679)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_8264_81679",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 17C66 13.6863 68.6863 11 72 11C75.3137 11 78 13.6863 78 17C78 20.3137 75.3137 23 72 23C68.6863 23 66 20.3137 66 17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66 17C66 13.6863 68.6863 11 72 11C75.3137 11 78 13.6863 78 17C78 20.3137 75.3137 23 72 23C68.6863 23 66 20.3137 66 17Z",
    fill: "url(#paint2_linear_8264_81679)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 17M78 17M78 17M66 17M72 11M78 17M72 23M66 17M72 23V21C69.7909 21 68 19.2091 68 17H66H64C64 21.4183 67.5817 25 72 25V23ZM78 17H76C76 19.2091 74.2091 21 72 21V23V25C76.4183 25 80 21.4183 80 17H78ZM72 11V13C74.2091 13 76 14.7909 76 17H78H80C80 12.5817 76.4183 9 72 9V11ZM72 11V9C67.5817 9 64 12.5817 64 17H66H68C68 14.7909 69.7909 13 72 13V11Z",
    fill: "white",
    mask: "url(#path-5-inside-1_8264_81679)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8264_81679",
    x: 0,
    y: -19,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_8264_81679"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_8264_81679",
    x: 20,
    y: 11,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8264_81679"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8264_81679"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8264_81679"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8264_81679",
    result: "effect2_dropShadow_8264_81679"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8264_81679",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_8264_81679",
    x: 54,
    y: 9,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8264_81679"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8264_81679"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_8264_81679"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8264_81679",
    result: "effect2_dropShadow_8264_81679"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8264_81679",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8264_81679",
    x1: 32,
    y1: 13,
    x2: 76,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A7282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#364153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8264_81679",
    x1: 32,
    y1: 13,
    x2: 76,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A7282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#364153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8264_81679",
    x1: 66,
    y1: 11,
    x2: 78,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A7282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#364153"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8264_81679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(42 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldOrders);
export default __webpack_public_path__ + "static/media/Hold Orders.a67304763ceb164949768a8d01e4d0ad.svg";
export { ForwardRef as ReactComponent };